import { axios } from '@/repositories'

export default {
  getTestAxios() {
    return axios.get('https://jsonplaceholder.typicode.com/todos/1').then(response => {
      return response ? response.data : response
    })
  }
}